import {Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges} from '@angular/core';
import {ShipmentsService} from "../services/shipments.service";
import {Shipment} from "../services/shipment";
import * as _ from "lodash";
import {ShipmentRoutesService} from "../services/shipment-routes.service";
import {ShipmentRoute} from "../services/shipment-route";
import {forkJoin} from "rxjs";

@Component({
    selector: 'app-shipment-details-popup',
    templateUrl: './shipment-details-popup.component.html',
    styleUrls: ['./shipment-details-popup.component.scss']
})
export class ShipmentDetailsPopupComponent implements OnInit {

    public loading: boolean = false;
    public saving: boolean = false;

    @Input() shipmentId: string;
    @Input() lastUpdate: number;

    public shipment: Shipment;
    public _shipment: Shipment;

    public allShipmentRoutes: ShipmentRoute[];
    public shipmentRoutes: ShipmentRoute[];

    constructor(public shipmentsService: ShipmentsService,
                public shipmentRoutesService: ShipmentRoutesService) {
    }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges) {
        const shipmentId: SimpleChange = changes.shipmentId;
        const lastUpdate: SimpleChange = changes.lastUpdate;
        if (shipmentId && (shipmentId.currentValue !== shipmentId.previousValue || lastUpdate.currentValue !== lastUpdate.previousValue)) {
            this.loadShipment();
        } else if (this.shipmentId && lastUpdate.currentValue !== lastUpdate.previousValue){
            this.loadShipment();
        }
    }

    loadShipment() {
        this.loading = true;
        forkJoin([
                this.shipmentRoutesService.getShipmentRoutes(),
                this.shipmentsService.getShipment(this.shipmentId, {combineEvents: true})
            ]
        ).subscribe(data => {
            this.allShipmentRoutes = data[0];
            this.shipment = data[1];
            this.shipmentRoutes = this.allShipmentRoutes.filter(route => route.branch === this.shipment.branch);
            this._shipment = _.cloneDeep(this.shipment);
            this.loading = false;
        });
    }
}
